module["exports"] = [
  "Авганистан",
  "Австралија",
  "Австрија",
  "Азербејџан",
  "Албанија",
  "Алжир",
  "Американска Самоа",
  "Американски Девствени Острови",
  "Ангила",
  "Ангола",
  "Андора",
  "Антарктик",
  "Антигва и Барбуда",
  "Аргентина",
  "Аруба",
  "Бангладеш",
  "Барбадос",
  "Бахами",
  "Бахреин",
  "Белгија",
  "Белиз",
  "Белорусија",
  "Бенин",
  "Бермуда",
  "Божиќен Остров",
  "Боливија",
  "Босна и Херцеговина",
  "Боцвана",
  "Бразил",
  "Брег на Слоновата Коска",
  "Британска Индоокеанска Територија",
  "Британски Девствени Острови",
  "Брунеј",
  "Бугарија",
  "Буркина Фасо",
  "Бурунди",
  "Бутан",
  "Валис и Футуна",
  "Вануату",
  "Венецуела",
  "Виетнам",
  "Габон",
  "Гамбија",
  "Гана",
  "Гваделуп",
  "Гвајана",
  "Гватемала",
  "Гвинеја",
  "Гвинеја-Бисао",
  "Германија",
  "Гернзи",
  "Гибралтар",
  "Гренада",
  "Гренланд",
  "Грузија",
  "Грција",
  "Гуам",
  "Данска",
  "Демократска Народна Република Кореја",
  "Доминика",
  "Доминиканска Република",
  "Египет",
  "Еквадор",
  "Екваторска Гвинеја",
  "Ел Салвадор",
  "Еритреја",
  "Ерменија",
  "Есватини",
  "Естонија",
  "Етиопија",
  "Замбија",
  "Западна Сахара",
  "Зелен ’Рт",
  "Зимбабве",
  "Израел",
  "Индија",
  "Индонезија",
  "Ирак",
  "Иран",
  "Ирска",
  "Исланд",
  "Источен Тимор",
  "Италија",
  "Јамајка",
  "Јапонија",
  "Јемен",
  "Јордан",
  "Јужна Африка",
  "Јужна Џорџија и Јужни Сендвички Острови",
  "Казакстан",
  "Кајмански Острови",
  "Камбоџа",
  "Камерун",
  "Канада",
  "Катар",
  "Кенија",
  "Кина",
  "Кипар",
  "Киргистан",
  "Кирибати",
  "Кокосови Острови",
  "Колумбија",
  "Комори",
  "Конго",
  "Костарика",
  "Куба",
  "Кувајт",
  "Кукови Острови",
  "Лаос",
  "Лесото",
  "Летонија",
  "Либан",
  "Либерија",
  "Либија",
  "Литванија",
  "Лихтенштајн",
  "Луксембург",
  "Мавританија",
  "Маврициус",
  "Мадагаскар",
  "Мајот",
  "Макао",
  "Македонија",
  "Малави",
  "Малдиви",
  "Малезија",
  "Мали",
  "Мали оддалечени острови на САД",
  "Малта",
  "Мароко",
  "Мартиник",
  "Маршалски Острови",
  "Мексико",
  "Микронезија",
  "Мјанмар",
  "Мозамбик",
  "Молдавија",
  "Монако",
  "Монголија",
  "Монтсерат",
  "Намибија",
  "Науру",
  "Непал",
  "Нигер",
  "Нигерија",
  "Никарагва",
  "Ниуе",
  "Нова Каледонија",
  "Нов Зеланд",
  "Норвешка",
  "Норфолшски Остров",
  "Обединети Арапски Емирати",
  "Обединето Кралство",
  "Оман",
  "Остров Буве",
  "Остров Ман",
  "Остров Хард и острови Мекдоналд",
  "Пакистан",
  "Палау",
  "Палестина (автономни територии)",
  "Панама",
  "Папуа Нова Гвинеја",
  "Парагвај",
  "Перу",
  "Питкернски Острови",
  "Полска",
  "Порторико",
  "Португалија",
  "Реинион",
  "Република Кореја",
  "Романија",
  "Руанда",
  "Русија",
  "Самоа",
  "Сан Марино",
  "Сао Томе и Принсипе",
  "Саудиска Арабија",
  "Свалбард и Јан Мајен",
  "Света Елена (остров)",
  "Света Луција",
  "Света Столица (Држава на градот Ватикан)",
  "Свети Вартоломеј",
  "Свети Винсент и Гренадини",
  "Свети Кристофер и Невис",
  "Свети Мартин (остров)",
  "Свети Пјер и Микелон",
  "Северни Маријански Острови",
  "Сејшели",
  "Сенегал",
  "Сиера Леоне",
  "Сингапур",
  "Сирија",
  "Словачка",
  "Словенија",
  "Соединети Американски Држави",
  "Соломонски Острови",
  "Сомалија",
  "Србија",
  "Судан",
  "Суринам",
  "Тајван",
  "Тајланд",
  "Танзанија",
  "Таџикистан",
  "Того",
  "Токелау",
  "Тонга",
  "Тринидад и Тобаго",
  "Тувалу",
  "Тунис",
  "Туркменистан",
  "Туркс и Кајкос",
  "Турција",
  "Уганда",
  "Узбекистан",
  "Украина",
  "Унгарија",
  "Уругвај",
  "Фарски Острови",
  "Филипини",
  "Финска",
  "Фиџи",
  "Фолкландски Острови",
  "Франција",
  "Француска Гвајана",
  "Француска Полинезија",
  "Француски јужни и арктички територии",
  "Хаити",
  "Холандија",
  "Холандски Антили",
  "Хонгконг",
  "Хондурас",
  "Хрватска",
  "Централноафриканската Република",
  "Црна Гора",
  "Чад",
  "Чешка",
  "Чиле",
  "Џерси",
  "Џибути",
  "Швајцарија",
  "Шведска",
  "Шпанија",
  "Шри Ланка"
];
